
import ColorPicker from '@com/components/color-picker';

export default {
  components: {
    ColorPicker: ColorPicker
  },

  props: {
    enable: {
      type: Boolean,
      default: false
    },
    currentColor: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      activeColorType: 'single',
      isOpen: false
    };
  },


  computed: {
    title: function title() {
      return this.$t('basic.colorFilter.title');
    }
  },

  watch: {
    enable: function enable(val) {
      this.isOpen = val;
    }
  },

  mounted: function mounted() {
    this.isOpen = this.enable;
  },


  methods: {
    handleSwitchChange: function handleSwitchChange(val) {
      this.$emit('toggle', val);
    }
  }
};